import CommunityNav from "./navigation/NavTileCommunity";
import SystemNav from "./navigation/NavTileSystem";

import CommunityUsers from "./community/Users";

import SystemStatus from "./system/Status";
import SystemDevices from "./system/Devices";
import SystemScenes from "./system/Scenes";

import UserPreview from "./user/Preview";

export const communityTile = {
	key: "Community",
	size: "small",
	component: CommunityNav,
};

export const communityUsersTile = {
	key: "CommunityUsers",
	size: "small",
	component: CommunityUsers,
};

export const systemTile = {
	key: "System",
	size: "small",
	component: SystemNav,
};

export const systemStatusTile = {
	key: "System Status",
	size: "small",
	component: SystemStatus,
};

export const systemDevicesTile = {
	key: "System Devices",
	size: "small",
	component: SystemDevices,
};

export const systemScenesTile = {
	key: "System Scenes",
	size: "small",
	component: SystemScenes,
};

export const userPreviewTile = {
	key: "User Preview",
	size: "small",
	component: UserPreview,
};
